import { Directive, OnInit, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[gcNullOnEmpty]',
  standalone: false,
})
export class NullOnEmptyDirective implements OnInit {
  constructor(@Self() private readonly control: NgControl) {}

  ngOnInit() {
    this.control.valueChanges.pipe(debounceTime(300)).subscribe((value: string) => {
      if (value?.trim() === '') {
        this.control.reset(null);
        this.control?.control?.markAsDirty();
      }
    });
  }
}
